import { collectionPath, defineModelSpec, orderBy } from '@elara/firebolt/shared';

import { PlaceSchema } from './schemas/place-schemas.js';
import { id } from './schemas/zod-types.js';

/**
 * The canonical `ModelSpec` for the places collection.
 * It defines the path (`places/${id}`) and the data shape for a place document.
 * The document id is Firestore-generated (not Google Place ID). Places are global
 * across users/trips so search results can be reused.
 */
export const PlaceModelSpec = defineModelSpec({
  path: collectionPath`places/${id}`,
  shape: PlaceSchema.shape,
  constraints: [orderBy('name')],
});

export type PlaceModelSpec = typeof PlaceModelSpec;
